/** @jsx jsx */
import React, { useMemo, useState } from "react";
import { Highlight } from "react-instantsearch-dom";
import { Row, Col, Skeleton } from "antd";
import { jsx, Flex, Text, Box, Image } from "theme-ui";
import HoverBox from "./hoverBox";
import {DATASOURCE_DETAILS} from '../DatasourceDetails';
import Action from "../Action";

const maturityBox = (maturity) => {
    let boxClass = "none";
    if (maturity === "EXPERIMENTAL") {
        boxClass = "red";
        return <Box className={`contrib-stat ${boxClass}`} />;
    }
    if (maturity === "BETA") {
        boxClass = "orange";
        return <Box className={`contrib-stat ${boxClass}`} />;
    }
    if (maturity === "PRODUCTION") {
        boxClass = "green";
        return <Box className={`contrib-stat ${boxClass}`} />;
    }
    return null;
};

const squareBox = (contribType, numPassed, numFailed) => {
    if (contribType) {
        let className = "none";
        const dataSource = "dataSource";
        if (numFailed >= 1 && numPassed >= 1) {
            className = "yellow";
        } 
        else if (numPassed >= 1 && numFailed === 0) {
            className = "green";
        } else if (numPassed === 0 && numFailed >= 1) {
            className = "red";
        }
        return (
            <div>
                <HoverBox
                    className={className}
                    numPassed={numPassed}
                    numFailed={numFailed}
                    source={dataSource}
                />
            </div>
        );
    }
    return <> </>;
};

const View = ({ hits, filters }) => {

    const [filterUrl, setFilterUrl] = useState('');

    useMemo(() => {
      if(filters && filters.subFilterValues && filters.subFilterValues.length > 0) {
        setFilterUrl(`?filterType=${filters.filterType}&gotoPage=${filters.gotoPage}&showFilters=${filters.showFilters}&viewType=${filters.viewType}&subFilterValues=${filters.subFilterValues.join(',')}`);
      } else if(filters) {
        setFilterUrl(`?filterType=${filters.filterType}&gotoPage=${filters.gotoPage}&showFilters=${filters.showFilters}&viewType=${filters.viewType}`);
      } else {
        setFilterUrl('');
      }
    }, [filters, filters.subFilterValues]);
    
    const res = (
        <Flex
            sx={{
                flexDirection: "column",
                backgroundColor: "#FFFFFF",
            }}
        >
            {hits.length !== 0 && <Row
                sx={{
                    backgroundColor: "#FAFAFA",
                    border: "1px solid #F0F0F0",
                    borderBottom: "1px solid #F0F0F0",
                    alignItems: "center",
                    display: "flex",
                }}
            >
                 <Col
                    lg={11}
                    md={12}
                    sx={{
                        borderRight: "1px solid #F0F0F0",
                        height: "40px",
                        textAlign: "right",
                    }}
                />
                <Col lg={2} md={1} />
                {DATASOURCE_DETAILS.map((image) => (
                    <Col span={1} key={image.image} type="flex" justify="center" align="middle" className="datasource-name">
                        <Image src={image.image} variant="avatar" sx={{ width: "20px" }} alt={image.displayName}/>
                        <span className="datasource_tool_tip">{image.displayName}</span>
                    </Col>
                ))}
            </Row>}

            {
        hits?.map((hit) => (
            <a
                key={hit.description.snake_name}
                href={`/expectations/${hit.description.snake_name}${filterUrl}`}
            >
                <Row
                    sx={{ height: "50px", borderBottom: "1px solid #F0F0F0" }}
                >
                    <Col
                        lg={11}
                        md={12}
                        type="flex"
                        justify="center"
                        sx={{
                            paddingLeft: "24px",
                            height: "100%",
                            borderRight: "1px solid #F0F0F0",
                            boxShadow: "1px 0px 2px #f0f0f0",
                        }}
                    >
                        <Flex
                            sx={{ alignItems: "center", gap: "10px", height: "100%" }}
                        >
                            {maturityBox(hit.library_metadata.maturity)}
                            <Text
                                sx={{
                                    color: "#262626",
                                    fontWeight: 600,
                                    wordWrap: "break-word",
                                }}
                            >
                                {" "}
                                <Highlight
                                    attribute="description.snake_name"
                                    hit={hit}
                                    tagName="strong"
                                />{" "}
                                <span sx={{fontWeight: 400}}> { hit.exp_type ? `(${hit.exp_type})` : '' } </span>
                            </Text>
                        </Flex>
                    </Col>
                    <Col lg={2} md={1} />
                    {DATASOURCE_DETAILS.map((item) => (
                        <Col
                            key={item.name}
                            span={1}
                            type="flex"
                            justify="center"
                            align="middle"
                            sx={{
                                height: "100%",
                            }}
                        >
                            <Flex
                                sx={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "100%",
                                    gap: "8px",
                                }}
                            >
                                {hit.backend_test_result_counts.findIndex(ele => ele.backend === item.name) !== -1
                            ? squareBox(
                                item.name,
                                hit.backend_test_result_counts[hit.backend_test_result_counts.findIndex(ele => ele.backend === item.name)]?.num_passed,
                                hit.backend_test_result_counts[hit.backend_test_result_counts.findIndex(ele => ele.backend === item.name)]?.num_failed
                            )
                            : squareBox("default", 0, 0)}
                            </Flex>
                        </Col>
                    )
                    )}
                </Row>
            </a>
        )
        )}
        {hits.length === 0 && <Flex sx={{ alignItems:'center', justifyContent:'center', py:'10px'}}>
        <Box sx={{minWidth:['270px', 'max-content']}}>
        <Action
        label="Can't find the Expectation you need? Create an Expectation."
        url="https://docs.greatexpectations.io/docs/guides/expectations/creating_custom_expectations/overview/"
        style="secondaryV2"
        fontsize="14px"
        sx={{
          "&:hover": {
            cursor: "pointer",
          },
        }} />
        </Box>
        </Flex>}
        
        </Flex>
    );
return res;
};


// const isMobile = false;

class DataSource extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: true,
            // isMobile,
        };
    }

    componentDidMount() {
    // enquireScreen((b) => {
    //   this.setState({
    //     isMobile: !!b,
    //   });
    // });
        this.setState({
            isLoaded: true,
        });
    }

    shouldComponentUpdate(nextProps) {
        const { dataset } = this.props;
        if (nextProps.dataset.length !== dataset.length) {
            return true;
        }
        // check for same length but different data
        const nextPropExpArr = nextProps.dataset.length === 0 ? [] : nextProps.dataset.map((obj) => obj._highlightResult.description.snake_name);
        const newPropExpArr = dataset.length === 0 ? [] : dataset.map((obj) => obj._highlightResult.description.snake_name);
        if (nextPropExpArr !== newPropExpArr) {
            return true;
        }
        return false;
    }

    render() {
        const { isLoaded } = this.state;
        const { dataset, filters } = this.props;
        filters.subFilterValues = (typeof window !== "undefined") ? window.expectationsFilter : [];
        if (!isLoaded) {
            return (
                <Row sx={{ marginTop: "32px" }}>
                    <Skeleton paragraph={{ rows: 4 }} />
                </Row>
            );
        }
        return <View hits={dataset} filters={filters} />;
    }
}

export default DataSource;
